import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "fallback"];
import { Component, Children } from 'react';
import { HiddenMeasure } from '../../utils/HiddenMeasure';
import { View } from '../../../components/View/View';
import { Flex } from '../../../components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders its children in a row, swapping in `fallback` when they don't fit the
 * available width.
 *
 * Known limitation: when Collapser is a flex child, it does not swap back to its
 * children after switching to `fallback`, even if the container has room. As a
 * flex item it is sized to its content, so its box stays at the fallback's width.
 */
export class Collapser extends Component {
  constructor(...args) {
    super(...args);
    this.resizeObservers = [];
    this.nowrapEl = null;
    this.wrapEl = null;
    this.state = {
      useFallback: false
    };
    this.checkFit = () => {
      if (!this.nowrapEl || !this.wrapEl) return;
      const nowrapWidth = this.nowrapEl.scrollWidth;
      const wrapWidth = this.wrapEl.offsetWidth;
      const overflows = nowrapWidth > wrapWidth;
      if (this.state.useFallback !== overflows) {
        this.setState({
          useFallback: overflows
        });
      }
    };
  }
  componentDidMount() {
    if (this.nowrapEl) this.observeResize(this.nowrapEl);
    if (this.wrapEl) this.observeResize(this.wrapEl);
  }
  componentWillUnmount() {
    this.resizeObservers.forEach(observer => observer.disconnect());
    this.resizeObservers = [];
  }
  observeResize(element) {
    const observer = new ResizeObserver(this.checkFit);
    observer.observe(element);
    this.resizeObservers.push(observer);
  }
  render() {
    const _this$props = this.props,
      {
        children,
        fallback
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const {
      useFallback
    } = this.state;

    // Wrap each child in the `Flex` component
    const wrappedChildren = Children.map(children, child => /*#__PURE__*/_jsx(Flex, {
      display: "inline-flex",
      as: "span",
      children: child
    }));
    return /*#__PURE__*/_jsxs(View, Object.assign({
      position: "relative"
    }, rest, {
      children: [useFallback ? fallback : wrappedChildren, /*#__PURE__*/_jsx(HiddenMeasure, {
        display: "inline-flex",
        "aria-hidden": "true",
        ref: ref => {
          this.nowrapEl = ref;
        },
        children: wrappedChildren
      }), /*#__PURE__*/_jsx(HiddenMeasure, {
        display: "inline-block",
        "aria-hidden": "true",
        ref: ref => {
          this.wrapEl = ref;
        },
        children: wrappedChildren
      })]
    }));
  }
}
Collapser.displayName = 'Collapser';